export default __webpack_public_path__ + "static/media/trylleby-property-09.d9249856.jpg";